<template>
  <Scenario route_type="v2"/>
</template>

<script>
import Scenario from "@/components/v2/common/views/core/scenario.vue";
export default {
    components:{
        Scenario
    }
}
</script>